export default {
      id: "flanders-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#flanders",
      toString: function () {
        return this.url;
      }
    }